import { post } from "@libs:axios";
import { CamelCasedPropertiesDeep } from "type-fest";

import {
  AuthDatabaseLoginAuthJwtLoginPostResponse,
  BodyAuthDatabaseLoginAuthJwtLoginPost,
} from "@:openapi";

export const login = ({
  username,
  password,
}: CamelCasedPropertiesDeep<BodyAuthDatabaseLoginAuthJwtLoginPost>) => {
  const formData = new FormData();
  formData.set("username", username);
  formData.set("password", password);
  return post<
    CamelCasedPropertiesDeep<AuthDatabaseLoginAuthJwtLoginPostResponse>
  >("/auth/jwt/login", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const logout = () => post<void>("/auth/jwt/logout");
